<div class="dona-page">
  <div class="container">
    <br /><br /><br />
    <br /><br />
    <!-- Title -->
    <h1 class="title">SOSTIENI COME<b>TRALCI</b></h1>
    <p class="subtitle">Scegli come supportare la nostra missione</p>

    <!-- Donation Links -->
    <div class="links">
      <!-- Stripe -->
      <a
        *ngIf="hasStripe"
        [href]="donazioni?.stripe?.link"
        target="_blank"
        rel="noopener noreferrer"
        class="link-button stripe"
      >
        <div class="icon stripe-icon">
          <img src="/icons/stripe.svg" width="30px" height="30px" />
        </div>
        <div class="text">
          <span class="label"
            >Carta di Credito /
            {{ isAndroid ? "Google Pay" : "Apple Pay" }}</span
          >
          <span class="sublabel">Powered by Stripe</span>
        </div>
        <div class="arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
          </svg>
        </div>
      </a>

      <!-- PayPal -->
      <a
        *ngIf="hasPaypal"
        [href]="donazioni?.paypal?.link"
        target="_blank"
        rel="noopener noreferrer"
        class="link-button paypal"
      >
        <div class="icon paypal-icon">
          <img src="/icons/paypal.png" width="30px" height="30px" />
        </div>
        <div class="text">
          <span class="label">PayPal</span>
          <span class="sublabel">Veloce e sicuro</span>
        </div>
        <div class="arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
          </svg>
        </div>
      </a>

      <!-- Bonifico -->
      <div
        *ngIf="hasBonifico"
        class="link-button bonifico-wrapper"
        [class.expanded]="showBonifico"
      >
        <button class="bonifico-header" (click)="toggleBonifico()">
          <div class="icon bonifico-icon">
            <img src="/icons/bank.svg" width="30" height="30" />
          </div>
          <div class="text">
            <span class="label">Bonifico Bancario</span>
            <span class="sublabel">Clicca per i dettagli</span>
          </div>
          <div class="arrow" [class.rotated]="showBonifico">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
              />
            </svg>
          </div>
        </button>

        <!-- Bonifico Details inside -->
        <div class="bonifico-details">
          <div class="detail-row">
            <span class="detail-label">IBAN</span>
            <span
              class="detail-value"
              (click)="copyToClipboard(donazioni?.bonifico?.iban || '')"
            >
              {{ donazioni?.bonifico?.iban }}
              <svg
                *ngIf="!ibanCopied"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="copy-icon"
              >
                <path
                  d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                />
              </svg>
              <svg
                *ngIf="ibanCopied"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="copy-icon done-icon"
              >
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
              </svg>
            </span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Intestatario</span>
            <span class="detail-value">{{
              donazioni?.bonifico?.intestatario
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- WhatsApp Channel -->
    <div *ngIf="hasWhatsapp" class="whatsapp-section">
      <div class="link-button whatsapp-wrapper" [class.expanded]="showWhatsapp">
        <button class="whatsapp-header" (click)="toggleWhatsapp()">
          <div class="icon whatsapp-icon">
            <img src="/icons/whatsapp.svg" width="30" height="30" />
          </div>
          <div class="text">
            <span class="label">Canale WhatsApp</span>
            <span class="sublabel">Ricevi aggiornamenti</span>
          </div>
          <div class="arrow" [class.rotated]="showWhatsapp">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
              />
            </svg>
          </div>
        </button>

        <div class="whatsapp-details">
          <p class="whatsapp-description">
            Canale dedicato al sostegno concreto dell'opera missionaria
            <strong>Come Tralci</strong>, con aggiornamenti, richieste di aiuto
            e testimonianze per camminare insieme e sostenere l'opera.
          </p>
          <a
            [href]="donazioni?.whatsapp?.link"
            target="_blank"
            rel="noopener noreferrer"
            class="whatsapp-join-btn"
          >
            Entra nel canale
          </a>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <p class="footer-text">Dio ti benedica!</p>
  </div>
</div>
